export default "/images/verified-icon.png?5510ca372b67376b47f5b3e1231d8f27";